import LoaderGif from '../images/loader.gif';

function Loader() {
    return (<img className='loader-absolute' src={LoaderGif} alt=''/>);
}

export default Loader;
